<template>
    <div class="content_box mobile_content">
        <div class="content">
            <div class="title_box">
                <div class="title">
                    <span>文档库</span>
                </div>
                <div class="title_desc">按产品+语言维护使用文档。上传会同步写入线上 OSS 目录（{产品}/{语言}/guide），老用户服务中心页实时可见；排序确认后同步更新 config.json。</div>
            </div>

            <div class="search_box">
                <el-form :inline="true" class="search-form form-list" label-width="100px">
                    <el-form-item>
                        <el-select v-model="searchProduct" placeholder="请选择产品" @change="onProductChange">
                            <el-option :label="item" :value="item" v-for="item in productOptions" :key="item"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>

            <!-- 语言 Tab -->
            <div class="lang_tabs">
                <div v-for="(label, key) in appData.lang" :key="key"
                    class="lang_tab" :class="{active: activeLang === key}" @click="switchLang(key)">
                    <span class="lang_dot" :class="langDotClass(key)"></span>
                    <span>{{ label }}</span>
                </div>
            </div>

            <!-- 搜索栏 -->
            <div class="search_box">
                <el-form :inline="true" class="search-form form-list" label-width="100px">
                    <el-form-item>
                        <el-input v-model="keyword" placeholder="按标题搜索" clearable @keyup.enter.native="filterTable" @clear="filterTable"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <div class="button search" @click="filterTable">
                            <span>查询</span>
                        </div>
                    </el-form-item>
                </el-form>
            </div>

            <div class="btn_box">
                <div class="btn_right_box">
                    <div class="button button2" @click="syncOss" v-if="roleCheck('103-103-102-102') && !sortState && !syncing">
                        <i class="el-icon-refresh"></i>
                        <span>同步OSS存量</span>
                    </div>
                    <div class="button button2 add" @click="openCreate" v-if="roleCheck('103-103-102-102') && !sortState">
                        <i class="el-icon-plus"></i>
                        <span>新增文档</span>
                    </div>
                    <div class="button button2" @click="inSortMode" v-if="roleCheck('103-103-102-102') && !sortState">
                        <span>排序</span>
                    </div>
                    <div class="button" @click="sortConfirm" v-if="sortState">
                        <span>确认排序</span>
                    </div>
                    <div class="button button2" @click="sortCancel" v-if="sortState">
                        <span>取消</span>
                    </div>
                </div>
            </div>

            <el-table :data="tableData" v-loading="loading">
                <el-table-column label="标题" prop="title" min-width="200">
                    <template slot-scope="scope">
                        <span v-if="!sortState">{{ scope.row.title }}</span>
                        <span v-else class="sort_index">{{ scope.$index + 1 }}. {{ scope.row.title }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="描述" prop="description" min-width="150">
                    <template slot-scope="scope">
                        <span>{{ scope.row.description || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="类型" width="100">
                    <template slot-scope="scope">
                        <span>{{ (scope.row.file_type || 'pdf').toUpperCase() }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="更新时间" width="160">
                    <template slot-scope="scope">
                        <span>{{ formDate(scope.row.updated_at) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="170">
                    <template slot-scope="scope">
                        <div class="button text" @click="openEdit(scope.row)" v-if="roleCheck('103-103-102-102') && !sortState">编辑</div>
                        <div class="button text del_btn" @click="delItem(scope.row)" v-if="roleCheck('103-103-102-102') && !sortState">删除</div>
                        <div class="button text" @click="sort(scope.$index, 'up')" v-if="sortState && scope.$index != 0">
                            <i class="el-icon-sort-up" title="上移"></i>
                        </div>
                        <div class="button text" @click="sort(scope.$index, 'down')" v-if="sortState && scope.$index != tableData.length - 1">
                            <i class="el-icon-sort-down" title="下移"></i>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

            <Tip ref="tip" :msg="delMsg" @tipBack="delConfirm"></Tip>

            <!-- 新增/编辑文档弹窗 -->
            <Gh-Dialog size="big" ref="editDialog" :title="dialogMode === 'create' ? '新增文档' : '编辑文档'" @dialogBack="confirmSubmit">
                <template v-slot:cancel_btn>
                    <span></span>
                </template>
                <template v-slot:content>
                    <el-form label-width="100px" :model="editForm">
                        <el-form-item label="产品">
                            <span>{{ searchProduct }}</span>
                        </el-form-item>
                        <el-form-item label="语言">
                            <span>{{ appData.lang[activeLang] }}</span>
                            <span class="form_tip">（由当前选中的语言 Tab 决定）</span>
                        </el-form-item>
                        <el-form-item label="标题" required>
                            <el-input v-model="editForm.title" placeholder="请输入文档标题" maxlength="100"></el-input>
                        </el-form-item>
                        <el-form-item label="描述">
                            <el-input v-model="editForm.description" placeholder="请输入描述，例如：快速入门指南" maxlength="200"></el-input>
                        </el-form-item>
                        <el-form-item label="文件类型">
                            <el-input v-model="editForm.fileType" placeholder="如 pdf" maxlength="20"></el-input>
                        </el-form-item>
                        <el-form-item label="文档文件" required v-if="dialogMode === 'create'">
                            <upload ref="doc_upload" :fileDire="uploadDire" :limit="1" @fileChange="fileChange">
                                <template slot="desc">
                                    <span slot="tip" class="el-upload__tip upload_desc">仅支持上传1个文档文件（如 PDF）</span>
                                </template>
                            </upload>
                        </el-form-item>
                        <el-form-item label="文档地址" v-if="dialogMode === 'edit'">
                            <a class="file_link" :href="editForm.fileUrl" target="_blank">{{ editForm.fileUrl }}</a>
                        </el-form-item>
                    </el-form>
                </template>
            </Gh-Dialog>
        </div>
    </div>
</template>
<script>
import aliOss from '../../../aliOss/index'
import upload from '../../../components/file/upload'

const OSS_URL_BASE = 'https://jhc-en.oss-ap-southeast-1.aliyuncs.com/'

export default({
    name: 'psc-guide-manage',
    data() {
        return {
            module: 'guide',
            searchProduct: '',
            activeLang: 'en',
            keyword: '',
            loading: false,
            allList: [],
            tableData: [],
            // config.json（排序同步）
            sortConfig: {},
            sortState: false,
            // 同步中状态
            syncing: false,
            // 产品列表
            productOptions: [],
            // 弹窗
            dialogMode: 'create',
            editForm: {
                id: '',
                title: '',
                description: '',
                fileType: 'pdf',
                ossKey: '',
                fileUrl: ''
            },
            delItemRow: null,
            delMsg: ''
        }
    },
    components: {
        upload
    },
    computed: {
        // 上传目录沿用线上老结构：product-service-center/{product}/{lang}/guide
        uploadDire() {
            return 'product-service-center/' + this.searchProduct + '/' + this.activeLang + '/' + this.module
        }
    },
    created() {
        this.loadProducts();
    },
    methods: {
        // 产品列表：优先产品管理(psc_product)，回退默认列表
        loadProducts() {
            this.api.pscProductList({}).then(res => {
                if (res.code === 200 && res.data && res.data.list && res.data.list.length > 0) {
                    this.productOptions = res.data.list.map(item => item.model)
                } else {
                    this.productOptions = this.appData.product.slice()
                }
                this.searchProduct = this.productOptions[0] || ''
                this.initData()
            }).catch(() => {
                this.productOptions = this.appData.product.slice()
                this.searchProduct = this.productOptions[0] || ''
                this.initData()
            })
        },
        initData() {
            aliOss.getFile('config.json').then(r => {
                this.sortConfig = JSON.parse(r.content)
                this.loadList()
            }).catch(() => {
                this.sortConfig = {}
                this.loadList()
            })
        },
        onProductChange() {
            this.loadList()
        },
        // 同步 OSS 存量内容到内容库（幂等，可重复执行）
        syncOss() {
            this.syncing = true
            const loading = this.$loading({
                lock: true,
                text: '正在扫描线上 OSS 并同步...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            this.api.pscLibrarySync({}).then(res => {
                if (res.code === 200) {
                    const d = res.data || {}
                    let msg = '扫描 ' + (d.scanned || 0) + ' 个文件，新增 ' + (d.inserted || 0) + ' 条，已存在跳过 ' + (d.skipped || 0) + ' 条，故障/问答/活动外链同步 ' + (d.cfg_synced || 0) + ' 条'
                    if (d.failed > 0) {
                        msg += '，失败 ' + d.failed + ' 条'
                    }
                    this.$message.success(msg)
                    this.initData()
                } else {
                    this.$message.error(res.msg || '同步失败')
                }
            }).catch(() => {
                this.$message.error('同步失败')
            }).finally(() => {
                this.syncing = false
                loading.close()
            })
        },
        // 拉当前产品的全语言数据，用于 Tab 完整度圆点和列表过滤
        loadList() {
            this.loading = true
            this.api.pscDocList({
                product: this.searchProduct
            }).then(res => {
                if (res.code === 200) {
                    this.allList = res.data.list || []
                } else {
                    this.allList = []
                }
                this.applySortFromConfig()
                this.filterTable()
                this.loading = false
            }).catch(() => {
                this.allList = []
                this.filterTable()
                this.loading = false
            })
        },
        // 用 config.json 中的排序（sort.guide）对当前语言列表排序，保持与线上老页一致
        applySortFromConfig() {
            const cfg = (this.sortConfig[this.searchProduct] || {})[this.activeLang] || {}
            const sortArr = (cfg.sort || {})[this.module]
            if (!sortArr) return
            this.allList.sort((a, b) => {
                const ia = sortArr.indexOf(this.ossFileName(a))
                const ib = sortArr.indexOf(this.ossFileName(b))
                return ia === -1 ? 1 : ib === -1 ? -1 : ia - ib
            })
        },
        // OSS 文件名（含 _ 前缀），与 config.json sort 数组元素一致
        ossFileName(item) {
            return (item.oss_key || '').split('/').pop()
        },
        filterTable() {
            let list = this.allList.filter(item => item.language === this.activeLang)
            if (this.keyword) {
                const kw = this.keyword.toLowerCase()
                list = list.filter(item => (item.title || '').toLowerCase().indexOf(kw) !== -1)
            }
            this.tableData = list
        },
        switchLang(lang) {
            this.activeLang = lang
            this.applySortFromConfig()
            this.filterTable()
        },
        // 完整度圆点：该语言条数 >= 该产品全语言中的最大条数为绿，否则黄
        langDotClass(lang) {
            const counts = {}
            let max = 0
            this.allList.forEach(item => {
                counts[item.language] = (counts[item.language] || 0) + 1
            })
            Object.keys(counts).forEach(key => {
                if (counts[key] > max) {
                    max = counts[key]
                }
            })
            if (max === 0) {
                return 'gray'
            }
            return (counts[lang] || 0) >= max ? 'green' : 'yellow'
        },
        resetForm() {
            this.editForm = {
                id: '',
                title: '',
                description: '',
                fileType: 'pdf',
                ossKey: '',
                fileUrl: ''
            }
        },
        openCreate() {
            this.dialogMode = 'create'
            this.resetForm()
            this.$refs.editDialog.show = true
            this.$nextTick(() => {
                if (this.$refs.doc_upload) {
                    this.$refs.doc_upload.init()
                }
            })
        },
        openEdit(row) {
            this.dialogMode = 'edit'
            this.editForm = {
                id: row.id,
                title: row.title,
                description: row.description,
                fileType: row.file_type || 'pdf',
                ossKey: row.oss_key || '',
                fileUrl: row.file_url
            }
            this.$refs.editDialog.show = true
        },
        fileChange(path, type) {
            if (type == 'upload') {
                this.editForm.ossKey = path
                this.editForm.fileUrl = OSS_URL_BASE + path
                // 按扩展名推断文件类型
                const name = path.split('/').pop().toLowerCase()
                if (name.lastIndexOf('.') !== -1) {
                    this.editForm.fileType = name.split('.').pop()
                }
            } else {
                this.editForm.ossKey = ''
                this.editForm.fileUrl = ''
            }
        },
        confirmSubmit() {
            if (!this.editForm.title) {
                this.$message.warning('请输入文档标题')
                return
            }
            if (this.dialogMode === 'create') {
                if (!this.editForm.fileUrl) {
                    this.$message.warning('请上传文档文件')
                    return
                }
                this.api.pscDocCreate({
                    product: this.searchProduct,
                    language: this.activeLang,
                    title: this.editForm.title,
                    description: this.editForm.description,
                    file_url: this.editForm.fileUrl,
                    file_type: this.editForm.fileType,
                    oss_key: this.editForm.ossKey
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('新增成功，已同步线上 OSS 目录')
                        this.$refs.editDialog.show = false
                        this.loadList()
                    } else {
                        this.$message.error(res.msg || '新增失败')
                    }
                })
            } else {
                this.api.pscDocUpdate({
                    id: this.editForm.id,
                    title: this.editForm.title,
                    description: this.editForm.description,
                    file_type: this.editForm.fileType
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('更新成功')
                        this.$refs.editDialog.show = false
                        this.loadList()
                    } else {
                        this.$message.error(res.msg || '更新失败')
                    }
                })
            }
        },
        delItem(row) {
            this.delItemRow = row
            this.delMsg = '确认删除文档「' + row.title + '」？将同时删除线上 OSS 文件（老用户页面将不再展示该文档）。'
            this.$refs.tip.show = true
        },
        delConfirm() {
            if (!this.delItemRow) {
                return
            }
            this.api.pscDocDelete({ id: this.delItemRow.id }).then(res => {
                if (res.code === 200) {
                    this.$message.success('删除成功')
                    // 同步删除 OSS 文件（尽力而为，失败不影响记录删除）
                    if (this.delItemRow.oss_key) {
                        aliOss.delFile(this.delItemRow.oss_key).catch(() => {})
                    }
                    this.loadList()
                } else {
                    this.$message.error(res.msg || '删除失败')
                }
            })
        },
        // ===== 排序模式：确认后写回 config.json，保持线上老页顺序一致 =====
        inSortMode() {
            if (this.tableData.length === 0) {
                this.$message.warning('当前语言暂无可排序的文档')
                return
            }
            this.sortState = true
        },
        sort(i, type) {
            const j = type === 'up' ? i - 1 : i + 1
            const temp = this.tableData[i]
            this.$set(this.tableData, i, this.tableData[j])
            this.$set(this.tableData, j, temp)
        },
        sortConfirm() {
            const names = this.tableData.map(item => this.ossFileName(item)).filter(name => !!name)
            if (!this.sortConfig[this.searchProduct]) {
                this.sortConfig[this.searchProduct] = {}
            }
            if (!this.sortConfig[this.searchProduct][this.activeLang]) {
                this.sortConfig[this.searchProduct][this.activeLang] = {}
            }
            if (!this.sortConfig[this.searchProduct][this.activeLang].sort) {
                this.sortConfig[this.searchProduct][this.activeLang].sort = {}
            }
            this.sortConfig[this.searchProduct][this.activeLang].sort[this.module] = names
            aliOss.putFile('config.json', this.sortConfig, 'application/json').then(() => {
                this.sortState = false
                this.$message.success('排序已同步到线上 config.json')
            }).catch(() => {
                this.$message.error('排序同步失败，请重试')
            })
        },
        sortCancel() {
            this.sortState = false
            this.applySortFromConfig()
            this.filterTable()
        }
    }
})
</script>
<style lang="less" scoped>
    .title_desc {
        margin-top: 8px;
        color: #999;
        font-size: 13px;
    }
    .lang_tabs {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-bottom: 16px;
        border-bottom: 1px solid #E8E9F1;
        padding-bottom: 12px;
        .lang_tab {
            display: inline-flex;
            align-items: center;
            padding: 6px 14px;
            border: 1px solid #E8E9F1;
            border-radius: 16px;
            cursor: pointer;
            font-size: 13px;
            color: #666;
            background: #fff;
            &:hover {
                color: @colorBlue;
                border-color: @colorBlue;
            }
            &.active {
                color: #fff;
                background: @colorBlue;
                border-color: @colorBlue;
            }
            .lang_dot {
                width: 8px;
                height: 8px;
                border-radius: 50%;
                margin-right: 6px;
                &.green {
                    background: #21a67a;
                }
                &.yellow {
                    background: #e6a23c;
                }
                &.gray {
                    background: #ccc;
                }
            }
        }
    }
    .btn_right_box {
        text-align: right;
    }
    .form_tip {
        color: #999;
        font-size: 12px;
    }
    .file_link {
        color: @colorBlue;
        word-break: break-all;
    }
    .sort_index {
        font-weight: 600;
    }
</style>



// WEBPACK FOOTER //
// src/view/app/product-service-center/guide-manage.vue